module.exports = __webpack_public_path__ + "static/media/text.f4b84fac.svg";